export default __webpack_public_path__ + "e62540fc5b9a82070a92ed710b2ab0fd.svg";